import React, { useState } from 'react'

import _ from 'lodash'
import { getTemplateDropDownPessoaContrato } from '../../utils/Template'
import { Filtro } from '../../utils/Filtro'
import { icons, routes } from '../../constants'
import apiService from '../../services/api.service'
import { Column } from 'primereact/column'
import { Dialog } from 'primereact/dialog'
import { PessoaFisicaFormPage } from '../../pages/pessoaFisica'
import { Button } from 'primereact/button'
import LtsLookup from './lts-lookup'
import '../../index.scss'
import { InputText } from 'primereact/inputtext'
import { getFiltroJoinUnidade } from '../../utils/filter-utils'

export default function LtsLookupPessoaContrato(props) {
  const [filters, setFilters] = useState([])
  const [showDialogAddNew, setShowDialogAddNew] = useState(false)
  const url = '/lottustech/pessoascontratos/all'

  const columns = [
    {
      field: 'oidPessoa',
      header: 'oidPessoa',
      columnKey: 'oidPessoa',
      sortable: false,
      filter: true,
    },
    {
      field: 'documentoPessoa',
      header: 'CPF',
      columnKey: 'documentoPessoa',
      sortable: true,
      filter: true,
    },
    {
      field: 'nomePessoa',
      header: 'Nome',
      columnKey: 'nomePessoa',
      sortable: true,
      filter: true,
    },
    {
      field: 'oidContrato',
      header: 'OID Contrato',
      columnKey: 'oidContrato',
      sortable: false,
      filter: false,
    },
    {
      field: 'numeroContrato',
      header: 'Núm. Contrato',
      columnKey: 'numeroContrato',
      sortable: true,
      filter: true,
    },
    {
      field: 'dataNascimento',
      header: 'Nascimento',
      columnKey: 'dataNascimento',
      sortable: true,
      filter: true,
    },
    {
      field: 'dataFalecimento',
      header: 'Falecimento',
      columnKey: 'dataFalecimento',
      sortable: true,
      filter: true,
    },
  ]

  const loadDataFn = (params) => {
    return apiService.post(url, params)
  }

  const onKeyPress = (e) => {
    const idValue = _.get(props, 'value', null)
    if (idValue) {
      const value = typeof idValue === 'string' ? idValue : _.get(idValue, 'value', null)
      const filters = [new Filtro('nomePessoa', value, 'CONTEM'), new Filtro('documentoPessoa', value, 'CONTEM')]
      const filter = {
        campo: 'filtro',
        valor: filters,
        tipoFiltro: 'OU',
      }
      setFilters([filter])
    }
  }

  const onInputFilter = (e) => {
    const value = e.value
    if (typeof value === 'string') {
      props.onChange({ nome: e.value, oid: null })
    } else {
      props.onChange(value)
    }
  }

  const resolveColumns = () => {
    return columns
  }

  const onResolvingColumn = () => {
    const columns_ = resolveColumns()
    return columns_
      .filter((col) => col.field === 'documentoPessoa' || col.field === 'nomePessoa' || col.field === 'numeroContrato')
      .map((col) => {
        // Remove props that should not be spread to DOM elements
        const { showFilterMenuOptions, showClearButton, showFilterMenu, ...columnProps } = col

        if (col.field === 'documentoPessoa') {
          return (
            <Column
              {...columnProps}
              key={col.field}
              bodyClassName="column-nr-documento-body-width"
              filterHeaderClassName="column-nr-documento-filter-header-width"
              headerClassName="column-nr-documento-header-width"
              filterElement={columnFilterElement(col)}
            />
          )
        }
        if (col.field === 'nomePessoa') {
          return <Column {...columnProps} key={col.field} filterElement={columnFilterElement(col)} style={{ width: '20em' }} />
        }
        if (col.field === 'numeroContrato') {
          return <Column {...columnProps} key={col.field} filterElement={columnFilterElement(col)} style={{ width: '7em' }} />
        }
        return null
      })
  }

  const columnFilterElement = (column) => {
    return <InputText style={{ width: '100%' }} name={column.field} onChange={(e) => onChangeTableFilter(column, e)} />
  }

  const onChangeTableFilter = (column, e) => {
    const campo = column.field

    //remove o filtro do campo atual com valor 'antigo'
    const newFilters = filters.filter((f) => f.campo !== campo)

    const valor = _.get(e, 'target.value', null)
    if (valor) {
      const tipoFiltro = campo === 'oid' ? 'IGUAL_A' : 'CONTEM'
      newFilters.push({ campo, valor, tipoFiltro })
    }

    setFilters(newFilters)
  }

  const resolveFilters = (filters) => {
    const filtroUnidade = getFiltroJoinUnidade(_.get(props, 'idUnidade', null))
    if (filtroUnidade) {
      filters.push(filtroUnidade)
    }
    return filters
  }

  const onClickAddButton = () => {
    setShowDialogAddNew(true)
  }

  const onHideDialogAddNew = () => {
    setShowDialogAddNew(false)
  }

  const getDialogAddNew = () => {
    const footer = (
      <div>
        <Button
          label={'Adicionar'}
          onClick={(e) => onConfirmAddNew(e)}
          icon={icons.PLUS_ICON}
          className="p-button-success"
        />
      </div>
    )

    return (
      <Dialog
        header={props.header}
        visible={showDialogAddNew}
        onHide={onHideDialogAddNew}
        modal={true}
        closable={true}
        style={{ width: '70%' }}
        contentStyle={{ maxHeight: '85%', overflow: 'auto' }}
        footer={footer}
      >
        <React.Fragment>
          <PessoaFisicaFormPage renderToolbar={false} />
        </React.Fragment>
      </Dialog>
    )
  }

  const onConfirmAddNew = (e) => {
    e.preventDefault()
    e.stopPropagation()
    const pessoa = props.statePessoaFisica.currentRecord
    const nome = _.get(pessoa, 'nome', null)
    if (nome) {
      const tipoChavePix = pessoa.tipoChavePix
      if (tipoChavePix) {
        pessoa.tipoChavePix = tipoChavePix.id
      }
      apiService
        .post(url, pessoa)
        .then((response) => {
          const nome = _.get(response, 'data.nome', null)
          const oid = _.get(response, 'data.oid', null)
          props.onChange({ nome, oid })
        })
        .catch((error) => {})
    } else {
      // exibir mensagem
    }
    onHideDialogAddNew()
  }

  const pathOnEditFn = () => {
    const oid = _.get(props, 'oidRecord', null)
    const rota = routes.PATH_PESSOA_FISICA

    if (oid) {
      return `${rota}/${oid}`
    }
    return `${rota}/novo`
  }

  const resolveDisplayValue = () => {
    const idValue = _.get(props, 'value', null)
    return _.get(idValue, 'value', null)
  }

  return (
    <React.Fragment>
      {getDialogAddNew()}
      <LtsLookup
        label={props.label}
        value={resolveDisplayValue()}
        name={props.name}
        field={props.field}
        history={props.history}
        autoCompleteTemplate={getTemplateDropDownPessoaContrato}
        onKeyPress={onKeyPress}
        onComplete={onKeyPress}
        onInputFilter={onInputFilter}
        pathOnEditFn={pathOnEditFn}
        header={props.header}
        columns={resolveColumns()}
        onResolvingColumn={onResolvingColumn}
        onChange={props.onChange}
        filters={filters}
        setFilters={setFilters}
        showAddButton={_.get(props, 'showAddButton', false)}
        onClickAddButton={onClickAddButton}
        loadDataFn={loadDataFn}
        resolveFilters={resolveFilters}
        editDisabled={props.editDisabled}
        disabled={props.disabled}
        editHidden={props.editHidden}
      />
    </React.Fragment>
  )
}
